import type { CustomCellRendererProps } from 'ag-grid-react';
import type { BulkManageRow } from '../types';
import AllocationDifferenceTooltip from '../../allocation-panel/AllocationDifferenceTooltip';
import React from 'react';
import { isNil } from 'lodash';

export type AllocationValue = {
  value: number;
  isPercentage: boolean;
  isForwardFilled: boolean;
};

export const AllocationValueCellRenderer = ({
  value,
  valueFormatted,
}: CustomCellRendererProps<BulkManageRow, AllocationValue>) =>
  isNil(value) ? null : (
    <AllocationDifferenceTooltip
      value={value.value}
      difference={0}
      hasDifference={false}
      isPercentageMode={value.isPercentage}
      isFillForward={value.isForwardFilled}
      usePortal
    >
      <span>
        {valueFormatted}
        {valueFormatted && value.isForwardFilled && <sup>*</sup>}
      </span>
    </AllocationDifferenceTooltip>
  );
